import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { useState, useMemo, useEffect } from "react";
import useBangKeoMatches from "@/hooks/useBangKeoMatches";
import Match from "@/components/Match";
import LoadingInner from "@/components/Loading";
import NoData from "@/components/NoData";
import MatchLeagues from "@/components/MatchLeagues";
import KbvDateRange from "@/components/DateRange";
import { BANG_KEO_PAGE_LIMIT, BANG_KEO_PAGE_PLUGIN_V1_LIMIT } from "@/contants";
import { useLiveData } from "@/hooks/useLiveData";
import { useLiveUpdates } from "@/hooks/useLiveUpdates";
import LoadMoreButton from "@/components/LoadMoreButton";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";


const KbvBangKeo = ({ type = "all" }) => {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [selectedDateValue, setSelectedDateValue] = useState(today);
  const { clearAllData } = useLiveData();

  const dateString =
    selectedDateValue === "live" ? today : selectedDateValue;
  const status =
    type === "ketqua" ? "end" : selectedDateValue === "live" ? "live" : "";

  const queryObject = useMemo(
    () => ({
      include: "homeTeam,awayTeam,odd,countOtherOdds,stats,events,insight",
      filterInclude: `date:${dateString}`,
      filterOdds: -1,
      cache: false,
      status,
      page: 1,
      limit: BANG_KEO_PAGE_PLUGIN_V1_LIMIT,
    }),
    [dateString, status]
  );

  const {
    leaguesWithMatches,
    loading,
    hasMore,
    isLoadingMore,
    handleLoadMore,
  } = useBangKeoMatches(queryObject, false);

  const matchIds = useMemo(
      () =>
        leaguesWithMatches.flatMap(
          (league) => league.matches?.map((match) => match.id) || [],
        ),
      [leaguesWithMatches],
  );
  
  // live updates for all match IDs
  useLiveUpdates(matchIds);
  // clear match data live 
  useEffect(() => {
    return () => {
      clearAllData();
    };
  }, [clearAllData]);

  return (
    <div className="mx-auto px-2 py-3 rounded-xl flex flex-col gap-2">
      {["all", "ketqua"].includes(type) && (
        <KbvDateRange
          value={selectedDateValue}
          direction={type === "ketqua" ? "backward" : "forward"}
          days={7}
          onChange={setSelectedDateValue}
        />
      )}
      {loading && <LoadingInner />}
      {
        !loading && (
          <>
            <div className="space-y-2 rounded-lg">
              {
                leaguesWithMatches.length === 0 ? (
                  <NoData message="Không có trận đấu nào" />
                    
                ) : (
                  leaguesWithMatches.map(({ league, matches }) => (
                    <MatchLeagues key={league.id} league={league} matches={matches} render={(match) => <Match key={match.id} match={match} /> } />
                  ))
                )

              }
            </div>
            <LoadMoreButton
              isLoading={isLoadingMore}
              onClick={handleLoadMore}
              loadingComponent={<LoadingInner />}
              hasMore={hasMore}
            />
          </>
        )
      }
    </div>
  );
};

export default KbvBangKeo;